import * as React from 'react';


var Tag = React.memo(function (props) {
    var type = props.type, className = props.className, text = props.text;
    if (props.size === 'small') {
        return (React.createElement("div", { className: "Tag pluggy " + type + " " + (className || '') + "small" }, text));
    }
    var isSelectedProp = props.isSelected, onClick = props.onClick, selectable = props.selectable, disabled = props.disabled;
    var initialSelected = isSelectedProp !== undefined ? isSelectedProp : false;
    var _a = React.useState(initialSelected), isSelected = _a[0], setIsSelected = _a[1];
    var handleTagClick = React.useCallback(function () {
        if (onClick) {
            onClick();
            return;
        }
        setIsSelected(function (prev) { return !prev; });
    }, [onClick]);
    // update the state every time the prop changes
    React.useEffect(function () {
        if (isSelectedProp === undefined) {
            return;
        }
        setIsSelected(isSelectedProp);
    }, [isSelectedProp]);
    var tagClassName = "Tag pluggy " + (className || '') + " " + (selectable ? 'selectable' : type) + " " + (disabled ? 'disabled' : '') + " " + (isSelected ? 'selected' : '') + " medium";
    return (React.createElement("div", { className: tagClassName, onClick: disabled ? undefined : handleTagClick }, text));
});
export { Tag };
